/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IBanco from 'Infotrack@Modelos/administracion/banco/entidades/banco';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@material-ui/core';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<IBanco>> => [
    {
        title: formatMessage({ id: 'banco.codigoBanco' }),
        field: 'CodigoBanco',
    },
    {
        title: formatMessage({ id: 'banco.nombreBanco' }),
        field: 'NombreBanco',
    },
    {
        title: formatMessage({ id: 'banco.estadoBanco' }),
        field: 'EstadoBanco',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, banco?: IBanco) => void,
    cargarBanco: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (banco: IBanco) => void
): Array<Action<IBanco>> => [
    {
        component: BotonRefrescar,
        icon: () => <RefreshIcon />,
        onClick: () => cargarBanco(),
        isFreeAction: true,
    },
    {
        component: BotonAgregar,
        icon: () => <AddIcon />,
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
    },
    {
        icon: () => <EditIcon color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as IBanco),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        icon: () => <DeleteIcon color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as IBanco),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<IBanco> = {
    maxBodyHeight: '50vh',
};
